import { Moment } from 'moment';
import { PhoneNumber } from './contact-info.model';

export interface EmergencyContact {
  readonly emergencyContactId: number | null;
  readonly modifiedDate: Moment | string | null;
  contactName: string;
  relationship: string | null;
  phoneNumbers: PhoneNumber[];
  isPrimary: boolean;
}

export function isEmergencyContactSaved(emergencyContact: EmergencyContact) {
  return emergencyContact.emergencyContactId && emergencyContact.emergencyContactId > 0;
}
